import { useRef, useState } from "react";
import { Camera, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { imgSrc } from "@/lib/categories";
import { uploadImage } from "@/lib/upload";

export function ReviewPhotos({ photos, onChange }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const files = [...(e.target.files || [])].slice(0, 3 - photos.length);
    if (!files.length) return;
    setBusy(true);
    const added = [];
    for (const file of files) {
      try {
        added.push(await uploadImage(api, file));
      } catch (err) { toast.error(errorMessage(err)); }
    }
    onChange([...photos, ...added]);
    setBusy(false);
    e.target.value = "";
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {photos.map((p, i) => (
        <div key={p} className="relative h-14 w-14 rounded-lg overflow-hidden border border-[#26334D]">
          <img src={imgSrc(p)} alt="" className="h-full w-full object-cover" />
          <button type="button" data-testid={`review-photo-remove-${i}`} onClick={() => onChange(photos.filter((x) => x !== p))}
            className="absolute top-0.5 right-0.5 bg-[#0B0F19]/80 rounded-full p-0.5"><X className="h-3 w-3" /></button>
        </div>
      ))}
      {photos.length < 3 && (
        <button type="button" data-testid="review-photo-upload" disabled={busy} onClick={() => ref.current?.click()}
          className="h-14 w-14 rounded-lg border border-dashed border-[#26334D] hover:border-[#FFB800] grid place-items-center text-slate-400 transition-colors">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Camera className="h-4 w-4" />}
        </button>
      )}
      <span className="text-[11px] text-slate-500">Up to 3 photos</span>
      <input ref={ref} type="file" multiple accept="image/*" hidden data-testid="review-photo-input" onChange={pick} />
    </div>
  );
}

export function PhotoStrip({ photos, rid }) {
  if (!photos?.length) return null;
  return (
    <div className="flex gap-2 mt-2">
      {photos.map((p, i) => (
        <a key={p} href={imgSrc(p)} target="_blank" rel="noopener noreferrer" data-testid={`review-photo-${rid}-${i}`}
          className="h-20 w-20 rounded-lg overflow-hidden border border-[#26334D] hover:border-[#FFB800] transition-colors">
          <img src={imgSrc(p)} alt="Traveler photo" loading="lazy" className="h-full w-full object-cover" />
        </a>
      ))}
    </div>
  );
}
